module.exports = __webpack_public_path__ + "img/LAST_ACTIVITIES.157dcd9f.svg";